(() => {
  document.querySelectorAll('[data-fh-finder]').forEach((finder) => {
    const result = finder.querySelector('[data-fh-result]');
    const image = finder.querySelector('[data-fh-finder-image]');
    const buttons = finder.querySelectorAll('[data-fh-result-text]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((option) => option.classList.remove('is-active'));
        button.classList.add('is-active');

        if (result) {
          result.textContent = button.getAttribute('data-fh-result-text') || '';
        }

        if (image && button.dataset.fhImageSrc) {
          image.classList.add('is-switching');
          window.setTimeout(() => {
            image.src = button.dataset.fhImageSrc;
            image.removeAttribute('srcset');
            image.alt = button.dataset.fhImageAlt || '';
            image.classList.remove('is-switching');
          }, 120);
        }
      });
    });
  });
})();
